<template>
  <div>
    <v-layout row wrap>
      <v-spacer></v-spacer>
      <v-btn
        fab
        x-small
        dark
        @click="openAddTaskDialog()"
        color="blue"
        class="mt-4 mr-2"
        ><v-icon>mdi-plus</v-icon></v-btn
      ><v-btn
        fab
        x-small
        dark
        @click="openMarkTaskCompleteDialog()"
        color="teal"
        class="mt-4 mr-2"
        ><v-icon>mdi-check</v-icon></v-btn
      ><v-btn
        fab
        x-small
        dark
        @click="openConfirmDeleteDialog()"
        color="red"
        class="mr-4 mt-4"
        ><v-icon>mdi-delete</v-icon></v-btn
      >
    </v-layout>

    <v-layout row wrap>
      <v-flex
        sm5
        xs12
        v-for="(task, i) in tasks"
        :key="i + Math.random()"
        class="mx-6 mt-1"
        ><v-alert
          border="left"
          :color="task.status == 2 ? 'green' : 'orange'"
          dark
        >
          <v-row align="center">
            <v-col class="grow">
              {{ task.description }}
              <br />
              <small>Assign to: {{ task.staff.name }} </small><br />
              <small>Due: {{ task.due_date }} | {{ task.due_time }}</small
              ><br />
              <small
                >Status:
                {{ task.status == 2 ? "Completed" : "Not Completed" }}</small
              >
            </v-col>
            <v-col class="shrink">
              <v-checkbox
                :value="task.id"
                v-model="selectedTasks"
                x-small
                class="my-2"
              ></v-checkbox>
            </v-col>
          </v-row> </v-alert
      ></v-flex>
    </v-layout>

    <GlobalDialogSlot
      :dialog="dialog"
      :title="
        confirmTaskCompletionDialog
          ? 'Mark Selected ' + (selectedTasks.length > 1 ? 'Tasks' : 'Task')
          : 'Add Task to ' + getCompanyLabels.matter
      "
      @close-dialog="closeDialog"
    >
      <v-card v-if="confirmTaskCompletionDialog">
        <v-row>
          <v-btn
            color="teal"
            @click="markTasksCompleted()"
            dark
            class="my-6 mx-auto"
            rounded
          >
            Mark Selected
            {{ selectedTasks.length > 1 ? " Tasks" : " Task" }} Completed
          </v-btn></v-row
        >
      </v-card>
      <v-card v-else-if="addTaskDialog">
        <v-layout row wrap>
          <v-flex>
            <v-textarea
              class="px-4 mx-4"
              label="Task Description"
              v-model="description"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm6 xs12>
            <DatePickerWithMenu
              @date-selected="getSelectedDate"
              label="Due Date"
              v-model="dueDate"
              class="px-4 mb-4"
            ></DatePickerWithMenu>
          </v-flex>
          <v-flex sm6 xs12>
            <v-text-field
              label="Due Time"
              v-model="dueTime"
              class="px-4 mx-4 mt-4"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex sm6 xs12>
            <ForeignKeyField
              class="mx-4"
              :foreignFieldValue="selectedStaff"
              label="Staff"
              table="staff"
              @field-selected="getSelectedStaff"
            ></ForeignKeyField>
          </v-flex>
          <v-flex sm6 xs12>
            <v-btn
              v-if="description"
              @click="saveTask()"
              class="mx-4 px-4 my-4"
              dark
              color="teal"
              rounded
              small
              ><v-icon left>mdi-plus</v-icon> Add Task</v-btn
            >
          </v-flex>
        </v-layout>
      </v-card>
    </GlobalDialogSlot>
    <GlobalConfirmDeleteDialog
      :item="selectedTasks.length > 1 ? 'Tasks' : 'Task'"
      @delete-confirmed="takeActionAfterDeleteConfirm"
    ></GlobalConfirmDeleteDialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";

export default {
  props: ["selectedCase"],
  components: {
    GlobalDialogSlot,
    GlobalConfirmDeleteDialog,
    DatePickerWithMenu,
    ForeignKeyField,
  },
  watch: {
    selectedCase() {
      this.getTask();
    },
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
  },
  mounted() {
    this.getTask();
  },
  data: () => ({
    dialog: false,
    tasks: [],
    selectedTasks: [],
    confirmTaskCompletionDialog: false,
    addTaskDialog: false,
    dueDate: new Date().toISOString().substr(0, 10),
    dueTime: null,
    description: null,
    selectedStaff: null,
  }),
  methods: {
    getTask() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-all-tasks-for-selected-case",
          { caseID: this.selectedCase.id },
          this.getAccessToken
        )
        .then((tasks) => {
          this.tasks = tasks;
          this.$store.commit("setLoader", false);
        });
    },
    openMarkTaskCompleteDialog() {
      if (this.selectedTasks.length < 1) {
        alert("At Least You Must Select One(1) Item !");
        event.preventDefault();
      } else {
        this.dialog = true;
        this.confirmTaskCompletionDialog = true;
      }
    },
    saveTask() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-task",
          {
            caseID: this.selectedCase.id,
            staffID: this.selectedStaff,
            description: this.description,
            dueDate: this.dueDate,
            dueTime: this.dueTime,
          },
          this.getAccessToken
        )
        .then((tasks) => {
          this.tasks = tasks;
          this.closeDialog();
          this.$store.commit("setLoader", false);
        });
    },
    getSelectedDate(selectedDate) {
      this.dueDate = selectedDate;
    },
    markTasksCompleted() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/mark-selected-tasks-completed",
          { selectedTasks: this.selectedTasks, caseID: this.selectedCase.id },
          this.getAccessToken
        )
        .then((tasks) => {
          this.tasks = tasks;
          this.closeDialog();
          this.$store.commit("setLoader", false);
        });
    },
    openAddTaskDialog() {
      this.dialog = true;
      this.addTaskDialog = true;
    },
    openConfirmDeleteDialog() {
      if (this.selectedTasks.length < 1) {
        alert("At Least Select One(1) Item !");
        event.preventDefault();
      } else {
        this.$store.commit("setGlobalConfirmDelete", true);
      }
    },
    takeActionAfterDeleteConfirm(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/delete-tasks",
            { selectedTasks: this.selectedTasks, caseID: this.selectedCase.id },
            this.getAccessToken
          )
          .then((tasks) => {
            this.tasks = tasks;
            this.$store.commit("setLoader", false);
          });
      }
    },
    getSelectedStaff(selectedStaff) {
      this.selectedStaff = selectedStaff[0];
    },
    closeDialog() {
      this.dialog = false;
      this.confirmTaskCompletionDialog = false;
      this.addTaskDialog = false;
      this.selectedTasks = [];
      this.dueDate = new Date().toISOString().substr(0, 10);
      this.dueTime = null;
      this.description = null;
      this.selectedStaff = null;
    },
  },
};
</script>

<style></style>
